import script from "./ScheduleLegend.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleLegend.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleLegend.vue?vue&type=style&index=0&id=446af0a5&lang=scss"

const __exports__ = script;

export default __exports__